import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const MailIcon: FC<IconProps> = ({ width = 21, height = 15, ...rest }) => (
  <Icon type="MailIcon" width={width} height={height} alt="MailIcon" {...rest} />
)
